













import { createNamespacedHelpers, useStore } from 'vuex-composition-helpers';

import { IWorkflow } from '@/models';
import { IRootState } from '@/store';
import {
  IWorkflowActions,
  IWorkflowGetters,
  IWorkflowMutations,
  IWorkflowStoreState
} from '@/store/workflow';

import { defineComponent, PropType } from '@vue/composition-api';

export default defineComponent({
  name: 'WorkflowStatusDisplay',

  props: {
    workflow: {
      type: Object as PropType<IWorkflow>,
      required: true
    }
  },

  setup(props) {
    const store = useStore<IRootState>();

    const { useGetters } = createNamespacedHelpers<
      IWorkflowStoreState,
      IWorkflowGetters,
      IWorkflowActions,
      IWorkflowMutations
    >(store, 'workflow');

    const { getWorkflowStateVisualByState } = useGetters([
      'getWorkflowStateVisualByState'
    ]);

    const stateVisual = getWorkflowStateVisualByState.value(
      props.workflow.state
    );

    return { stateVisual };
  }
});
